export const trendingMovies = [
  {
    id: "trending-1",
    title: "流浪地球3",
    englishTitle: "The Wandering Earth III",
    category: "movie",
    rating: 8.9,
    year: 2026,
    region: "中国大陆",
    genre: "科幻 / 冒险",
    duration: "148分钟",
    description: "太阳急速老化，将持续膨胀吞噬地球。人类面临前所未有的生存危机，联合政府决定启动「移山计划」，利用上万台行星发动机推动地球逃离太阳系，踏上长达2500年的宇宙流浪之旅。",
    poster: "https://readdy.ai/api/search-image?query=A%20cinematic%20movie%20poster%20for%20a%20Chinese%20sci-fi%20film%20featuring%20a%20giant%20planet%20earth%20with%20massive%20engines%20in%20space%2C%20dramatic%20lighting%2C%20dark%20atmosphere%2C%20orange%20and%20blue%20color%20scheme%2C%20epic%20scale%2C%20minimal%20text%20space%2C%20professional%20movie%20poster%20design%2C%20cinematic%20quality&width=600&height=840&seq=poster-trending-1&orientation=portrait",
    updateTime: "2026-08-09",
    isHot: true,
  },
  {
    id: "trending-2",
    title: "封神第二部：战火西岐",
    englishTitle: "Creation of the Gods II",
    category: "movie",
    rating: 8.7,
    year: 2026,
    region: "中国大陆",
    genre: "奇幻 / 动作 / 古装",
    duration: "156分钟",
    description: "殷商末年，纣王暴虐无道。姜子牙携封神榜下山，辅佐周室。西岐大军与殷商展开惊世对决，神魔大战一触即发，一场关于命运与选择的史诗传奇由此展开。",
    poster: "https://readdy.ai/api/search-image?query=A%20mythological%20Chinese%20fantasy%20movie%20poster%20with%20ancient%20warriors%20in%20elaborate%20armor%2C%20mythical%20beasts%2C%20dramatic%20battle%20scene%2C%20fiery%20background%2C%20epic%20cinematic%20composition%2C%20dark%20and%20golden%20tones%2C%20professional%20movie%20poster%20design&width=600&height=840&seq=poster-trending-2&orientation=portrait",
    updateTime: "2026-08-08",
    isHot: true,
  },
  {
    id: "trending-3",
    title: "哪吒之魔童闹海",
    englishTitle: "Nezha: The Devil Child Rises",
    category: "anime",
    rating: 9.2,
    year: 2026,
    region: "中国大陆",
    genre: "动画 / 奇幻 / 冒险",
    duration: "132分钟",
    description: "天劫之后，哪吒与敖丙的灵魂虽得以保存，但肉身即将消散。太乙真人打算用七色宝莲为二人重塑肉身，然而在重塑肉身的过程中却遇到了重重困难，哪吒与敖丙的命运又将何去何从？",
    poster: "https://readdy.ai/api/search-image?query=A%20Chinese%20animated%20movie%20poster%20featuring%20a%20young%20mythological%20warrior%20with%20flaming%20hair%20and%20red%20silk%20ribbons%2C%20dynamic%20action%20pose%2C%20vibrant%20red%20and%20gold%20color%20palette%2C%20ink%20painting%20style%20elements%2C%20cinematic%20anime%20poster%20design&width=600&height=840&seq=poster-trending-3&orientation=portrait",
    updateTime: "2026-08-07",
    isHot: true,
  },
  {
    id: "trending-4",
    title: "酱园弄",
    englishTitle: "The Sauce Garden Murder",
    category: "movie",
    rating: 8.5,
    year: 2026,
    region: "中国大陆",
    genre: "悬疑 / 犯罪 / 剧情",
    duration: "135分钟",
    description: "上世纪四十年代的上海，一桩离奇命案在酱园弄发生。警探抽丝剥茧追查真相，却发现案件背后隐藏着更为复杂的利益纠葛与人性考验，每一个线索都指向一个令人震惊的结局。",
    poster: "https://readdy.ai/api/search-image?query=A%20mystery%20thriller%20movie%20poster%20set%20in%201940s%20Shanghai%2C%20film%20noir%20style%2C%20rainy%20alleyway%2C%20silhouetted%20figures%2C%20vintage%20atmosphere%2C%20dark%20and%20moody%20lighting%2C%20red%20neon%20accents%2C%20professional%20movie%20poster%20design&width=600&height=840&seq=poster-trending-4&orientation=portrait",
    updateTime: "2026-08-06",
    isHot: true,
  },
  {
    id: "trending-5",
    title: "长安的荔枝",
    englishTitle: "The Lychee of Chang'an",
    category: "tv",
    rating: 8.8,
    year: 2026,
    region: "中国大陆",
    genre: "古装 / 剧情 / 历史",
    duration: "40集",
    description: "大唐天宝年间，长安城的小吏李善德突然接到一个任务：要在贵妃诞日之前，从岭南运来新鲜荔枝。荔枝「一日色变，二日香变，三日味变」，而岭南距长安五千余里，这几乎是一个不可能完成的任务。",
    poster: "https://readdy.ai/api/search-image?query=A%20historical%20Chinese%20TV%20drama%20poster%20set%20in%20Tang%20Dynasty%20Changan%2C%20ancient%20city%20background%2C%20traditional%20Chinese%20clothing%2C%20warm%20golden%20tones%2C%20elegant%20composition%2C%20lychees%20as%20visual%20motif%2C%20professional%20drama%20poster%20design&width=600&height=840&seq=poster-trending-5&orientation=portrait",
    updateTime: "2026-08-05",
    isHot: true,
  },
  {
    id: "trending-6",
    title: "大奉打更人",
    englishTitle: "The Nightwatchman of Dafeng",
    category: "tv",
    rating: 8.6,
    year: 2026,
    region: "中国大陆",
    genre: "古装 / 奇幻 / 悬疑",
    duration: "36集",
    description: "现代警校毕业的许七安穿越到大奉王朝，成为了一名打更人。在这个充满玄幻色彩的世界里，他凭借现代刑侦知识与超凡天赋，破解一桩桩离奇案件，逐渐揭开王朝背后隐藏的惊天秘密。",
    poster: "https://readdy.ai/api/search-image?query=A%20Chinese%20fantasy%20TV%20drama%20poster%20with%20a%20nightwatchman%20in%20traditional%20black%20uniform%20holding%20a%20lantern%2C%20mysterious%20ancient%20city%20at%20night%2C%20supernatural%20elements%2C%20dark%20blue%20and%20warm%20orange%20contrast%2C%20professional%20drama%20poster%20design&width=600&height=840&seq=poster-trending-6&orientation=portrait",
    updateTime: "2026-08-04",
    isHot: false,
  },
  {
    id: "trending-7",
    title: "剑来",
    englishTitle: "Sword Is Coming",
    category: "anime",
    rating: 8.9,
    year: 2026,
    region: "中国大陆",
    genre: "动画 / 武侠 / 奇幻",
    duration: "24集",
    description: "大千世界，无奇不有。少年陈平安，父母双亡，家境贫寒。在命运的推动下，他踏上了一条充满未知的修行之路。一剑在手，天下我有——且看平凡少年如何在这方天地间写下属于自己的传奇。",
    poster: "https://readdy.ai/api/search-image?query=A%20Chinese%20donghua%20poster%20featuring%20a%20young%20swordsman%20in%20flowing%20robes%20with%20a%20glowing%20sword%2C%20ink%20wash%20painting%20style%2C%20mountainous%20landscape%2C%20dynamic%20wind%20effects%2C%20ethereal%20atmosphere%2C%20professional%20anime%20poster%20design&width=600&height=840&seq=poster-trending-7&orientation=portrait",
    updateTime: "2026-08-03",
    isHot: false,
  },
  {
    id: "trending-8",
    title: "庆余年第二季",
    englishTitle: "Joy of Life Season 2",
    category: "tv",
    rating: 9.0,
    year: 2026,
    region: "中国大陆",
    genre: "古装 / 权谋 / 喜剧",
    duration: "36集",
    description: "范闲从北齐归来，发现京都风云变幻。各方势力暗流涌动，一场更大的阴谋正在酝酿。面对更加复杂的局势，范闲将如何凭借自己的智慧与勇气，在这盘大棋中杀出一条血路？",
    poster: "https://readdy.ai/api/search-image?query=A%20Chinese%20historical%20drama%20poster%20with%20a%20scholarly%20man%20in%20luxurious%20traditional%20robes%2C%20palace%20intrigue%20theme%2C%20rich%20golden%20and%20deep%20red%20tones%2C%20elegant%20composition%2C%20professional%20TV%20drama%20poster%20design&width=600&height=840&seq=poster-trending-8&orientation=portrait",
    updateTime: "2026-08-02",
    isHot: false,
  },
];

export const latestUpdates = [
  {
    id: "update-1",
    title: "异人之下 第二季",
    episode: "第18集",
    category: "tv",
    updateTime: "2小时前",
  },
  {
    id: "update-2",
    title: "凡人修仙传",
    episode: "第126集",
    category: "anime",
    updateTime: "3小时前",
  },
  {
    id: "update-3",
    title: "孤注一掷2",
    episode: "HD高清",
    category: "movie",
    updateTime: "5小时前",
  },
  {
    id: "update-4",
    title: "天启异闻录",
    episode: "第24集(完)",
    category: "tv",
    updateTime: "6小时前",
  },
  {
    id: "update-5",
    title: "星辰变 第六季",
    episode: "第8集",
    category: "anime",
    updateTime: "8小时前",
  },
  {
    id: "update-6",
    title: "三大队",
    episode: "HD高清",
    category: "movie",
    updateTime: "10小时前",
  },
  {
    id: "update-7",
    title: "狂飙时代",
    episode: "第32集",
    category: "tv",
    updateTime: "12小时前",
  },
  {
    id: "update-8",
    title: "斗破苍穹 年番",
    episode: "第98集",
    category: "anime",
    updateTime: "14小时前",
  },
  {
    id: "update-9",
    title: "年会不能停2",
    episode: "HD高清",
    category: "movie",
    updateTime: "16小时前",
  },
  {
    id: "update-10",
    title: "乘风破浪的姐姐 第六季",
    episode: "第10期",
    category: "variety",
    updateTime: "18小时前",
  },
];

export const categories = [
  {
    key: "movie",
    name: "电影",
    icon: "ri-film-line",
    count: 12580,
    description: "海量高清电影资源，涵盖动作、喜剧、科幻、悬疑、爱情等多种类型",
  },
  {
    key: "tv",
    name: "电视剧",
    icon: "ri-tv-line",
    count: 8960,
    description: "热门电视剧全集，国产剧、美剧、韩剧、日剧一网打尽",
  },
  {
    key: "anime",
    name: "动漫",
    icon: "ri-paint-brush-line",
    count: 6540,
    description: "最新最热动漫连载，国漫、日漫、欧美动漫精彩不断",
  },
  {
    key: "variety",
    name: "综艺",
    icon: "ri-movie-line",
    count: 4320,
    description: "热门综艺节目，真人秀、脱口秀、音乐竞演应有尽有",
  },
];

export const faqs = [
  {
    question: "91影视是否需要注册才能观看？",
    answer: "不需要。91影视坚持免费开放的理念，所有影视资源均可在线免费观看，无需注册、无需登录、无需会员，打开网站即可畅享海量高清内容。",
  },
  {
    question: "91影视支持哪些设备观看？",
    answer: "91影视全面支持PC端、平板、手机等多种终端设备。无论您使用的是Windows、Mac、iOS还是Android系统，都可以流畅访问91影视，随时随地追剧看片。",
  },
  {
    question: "91影视的资源更新速度如何？",
    answer: "91影视拥有专业的内容更新团队，热门电影、电视剧、动漫、综艺资源上线后24小时内即可同步更新。部分热门资源甚至在首播后数小时内就能在91影视找到。",
  },
  {
    question: "91影视的画质怎么样？",
    answer: "91影视提供从流畅到超清蓝光多种画质选择，主流资源均支持1080P高清播放。部分热门资源更提供4K超清画质，让您享受极致的观影体验。",
  },
  {
    question: "如何联系91影视的客服？",
    answer: "您可以通过关于我们页面的联系方式与我们取得联系，包括电子邮件、在线反馈表单等方式。我们会在24小时内回复您的咨询与建议。",
  },
  {
    question: "91影视是否提供下载功能？",
    answer: "91影视目前主要提供在线观看服务。我们致力于为用户提供流畅的在线观影体验，让您无需等待下载即可享受精彩内容。部分资源支持缓存以便离线观看。",
  },
];

export const siteStats = {
  totalMovies: 12580,
  totalTVShows: 8960,
  totalAnime: 6540,
  totalVariety: 4320,
  dailyVisitors: "1,280,000+",
  monthlyActive: "38,000,000+",
};